import { Pipe, PipeTransform } from '@angular/core'
import { HelperService } from '../services/helper.service'

@Pipe({
    name: 'formatNumberSeparator',
    standalone: false
})
export class FormatNumberSeparatorPipe implements PipeTransform {
  transform(value: any, separator: string = ' '): string {
    if (HelperService.isNullOrUndefined(value)) {
      return ''
    }
    return value.toString().replace(/(?!^)(?=(?:\d{3})+$)/g, separator)
  }
}
